export default __webpack_public_path__ + "static/media/sport.d8d2291d.jpeg";